export default __webpack_public_path__ + "static/media/@robertapazulini.96696563.jpg";